'use client';

import React from 'react';
import styles from './Spinner.module.css';

interface LoaderProps {
    size?: 'small' | 'medium' | 'large' | 'extra-large';
    text?: string;
    showOverlay?: boolean;
    className?: string;
}

const Loader: React.FC<LoaderProps> = ({
    size = 'medium',
    text,
    showOverlay = false,
    className = ''
}) => {
    const spinnerClasses = `${styles.loadingSpinner} ${styles[size]}`;

    if (showOverlay) {
        return (
            <div className={`${styles.loadingOverlay} ${className}`}>
                <div className={spinnerClasses} />
                {text && <p className={styles.loadingText}>{text}</p>}
            </div>
        );
    }

    return (
        <div className={`${styles.loaderContainer} ${className}`}>
            <div className={spinnerClasses} />
            {text && <p className={styles.loadingText}>{text}</p>}
        </div>
    );
};

export default Loader;
